<script lang="ts">
	import {
		sensorPriorityDevForce,
		sensorPriorityDevHudFamily,
		sensorPriorityDevHudIsBle,
		setSensorPriorityDevForce,
	} from 'src/stores/features/dev/sensor-priority-dev-state';
	import PriorityLayoutDevHud from 'src/components/Sidepanel/PriorityLayoutDevHud.svelte';
	import {
		sensorPriorityDevOptionsFor,
		type SensorPriorityDevForce,
	} from 'src/helpers/sensor_priority_layout';

	$: hudOptions = sensorPriorityDevOptionsFor($sensorPriorityDevHudFamily, $sensorPriorityDevHudIsBle);

	const onSelect = (id: string) => {
		setSensorPriorityDevForce(id as SensorPriorityDevForce);
	};
</script>

<PriorityLayoutDevHud
	options={hudOptions}
	selectedId={$sensorPriorityDevForce}
	idPrefix="sensor-priority-dev"
	{onSelect}
/>
